module.exports = __webpack_public_path__ + "static/media/aviation.f200700a.svg";